import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { MatterRequestUserField } from '../../hooks/useSelectMatterRequestUser';
import { useMatterRequestUserSelect } from './useMatterRequestUserSelect';

interface MatterRequestUserSelectProps {
  field: MatterRequestUserField;
  onOpenPicker: () => void;
  onClear: () => void;
  disabled?: boolean;
}

const userFieldLabelKeys: Record<MatterRequestUserField, { label: string; placeholder: string }> = {
  owner: { label: 'matter:owner', placeholder: 'matterRequest:selectOwner' },
  responsible: {
    label: 'matterRequest:matterResponsible',
    placeholder: 'matterRequest:selectResponsible',
  },
};

/**
 * Its own component so the user list is only fetched where the field is rendered. It renders the
 * trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const MatterRequestUserSelect = ({
  field,
  onOpenPicker,
  onClear,
  disabled,
}: Readonly<MatterRequestUserSelectProps>) => {
  const { t } = useTranslation();
  const select = useMatterRequestUserSelect(field);

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t(userFieldLabelKeys[field].label)}
      placeholder={t(userFieldLabelKeys[field].placeholder)}
      searchPlaceholder={t('common:searchUsers')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      disabled={disabled}
      data-testid={`select-${field}-button`}
    />
  );
};

export default MatterRequestUserSelect;
